import { render, staticRenderFns } from "./OrderSettings.vue?vue&type=template&id=45588446"
import script from "./OrderSettings.vue?vue&type=script&lang=js"
export * from "./OrderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports